export const environment = {
  production: false,
  name: 'staging',
  apiUrl: 'https://api.airgateway.work',
  apiUrlV1_5: 'https://api.airgateway.work/v1.5',
  keycloakUrl: 'https://auth.airgateway.work',
  bpUrl: 'https://web.bookingpad.work',
  registerAvailable: true,
};
